// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const it = {
    'countryCode': 'it_it',
    'Account creation': 'Creazione Account',
    'Add address': 'Aggiungi indirizzo',
    'Address': 'Indirizzo',
    'Address label': 'Nome indirizzo',
    'Address label placeholder': 'per esempio: casa, lavoro...',
    'Agreement': 'consenso',
    'Amount': 'Importo',
    'Apply': 'Applica',
    'Apply Discount': 'Applica sconto',
    'Apply Gift Card': 'Utilizza il credito',
    'Are you sure you want to delete this item from cart': 'Sei sicuro di voler cancellare questo articolo dal carrello?',
    'Are you sure you want to move this item to wishlist?': 'Sei sicuro di voler spostare questo articolo nella wishlist?',
    'articles': 'Articoli',
    'Articles': 'Articoli',
    'articles inside': 'oggetti presenti',
    'Available amount': 'Somma disponibile',
    'Back': 'Indietro',
    'Back to cart': 'Torna al carrello',
    'Back to shopping': 'Torna allo shopping',
    'Back to store': 'Torna allo store',
    'Billing address': 'Indirizzo di<br>fatturazione',
    'Billing address is the same as the shipping address': 'I dati di fatturazione e spedizione coincidono',
    'Buy': 'Acquista',
    'Buy Now': 'Acquista ora',
    'Cancel': 'Annulla',
    'Cannot apply Gift Card': 'Impossibile applicare il credito della carta regalo',
    'Cannot apply glam card points': 'Non è stato possibile applicare i punti della tua WE Card',
    'Card': 'Carta',
    'Cart': 'Carrello',
    'Cart content': 'Contenuto Carrello',
    'Change': 'Cambia',
    'Change address': 'Cambia indirizzo',
    'Change e-mail': 'Cambia email',
    'Change pickup point': 'Modifica punto di ritiro',
    'Check zip code': 'Controlla il CAP',
    'Choose a shipping method in order to proceed': 'Per proseguire seleziona il metodo di spedizione',
    'Choose a store for the pick-up in order to proceed': 'Per proseguire seleziona il negozio per il ritiro',
    'Choose a zipcode in order to proceed': 'Per proseguire seleziona il CAP',
    'City': 'Città',
    'Close': 'Chiudi',
    'Closed': 'Chiuso',
    'Color': 'Colore',
    'Complete your order': 'Concludi l\'ordine',
    'Condizioni di vendita': 'Condizioni di vendita',
    'Confirm': 'Conferma',
    'Continue': 'Avanti',
    'Continue as guest': 'Prosegui\ncome ospite',
    'Country': 'Paese',
    'Coupon': 'Coupon',
    'Coupon Code': 'Codice Sconto',
    'Credit Card': 'Carta di credito',
    'Credit Card Number': 'Numero della carta',
    'data': 'dati',
    'Date of birth': 'Data di nascita',
    'Date of Birth': 'Data di nascita',
    'dd/mm/yyyy': 'gg/mm/aaaa',
    'Delete': 'Elimina',
    'Delivery:': 'Consegna:',
    'Description': 'Descrizione',
    'Do you have a discount code?': 'Hai un codice sconto?',
    'Enter your Gift Card here': 'Inserisci qui la tua Gift Card',
    'do-login': 'Effettua il login',
    'done': 'finito',
    'E-mail address': 'Email',
    'Edit': 'Modifica',
    'Edit address': 'Modifica indirizzo',
    'Edit Cart': 'Modifica carrello',
    'Email': 'E-mail',
    'Email and telephone number': 'E-mail e numero di telefono',
    'email-remainder': 'Ti abbiamo inviato una mail per resettare la password. Clicca sul link che troverai al suo interno.',
    'Empty credit card fields': 'Per favore compila i dati della carta di credito',
    'Enter shipping address': 'Inserisci l\'indirizzo di consegna',
    'Enter the points to be used here': 'Inserisci qui i punti da utilizzare',
    'Error during payment authorization': 'Errore durante l\'autorizzazione di pagamento',
    'Error during registration': 'Errore durante la registrazione',
    'Expire Date': 'Scadenza',
    'Female': 'Donna',
    'Firstname': 'Nome',
    'Forgot your password?': 'Hai dimenticato la password?',
    'Free': 'Gratuito',
    'freeshippingmsg': '<strong>Aggiungi {tot}</strong> e ti <strong>regaliamo</strong> la spedizione',
    'Friday': 'Venerdì',
    'From': 'Da',
    'Gender': 'Sesso',
    'Gift': 'Messaggio d\'auguri',
    'Gift Card': 'Gift Card',
    'Gift Card Amount': 'Somma della Gift Card',
    'Gift card and discount codes': 'Gift card e codici sconto',
    'Gift Card Code': 'Codice Gift Card',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Sconto punti WE Card',
    'glamcard-bonusapplied': 'Applicati {bonus} punti della tua WE Card',
    'Go to checkout': 'Vai alla cassa',
    'Go to payment': 'Vai al metodo di pagamento',
    'Go to shipping': 'Vai alla spedizione',
    'Go to summary': 'Vai al pagamento',
    'Greeting card': 'Biglietto d\'auguri',
    'Home delivery cost': 'Costo consegna a casa',
    'How many points do you want to use?': 'Quanti punti vuoi usare?',
    'How much bonus do you want to use?': 'Quanto bonus vuoi usare?',
    'I don\'t want to receive the invoice': 'Non desidero ricevere fattura',
    'I want to receive the invoice': 'Desidero ricevere fattura',
    'Identical to shipping address': 'Uguale ad indirizzo di spedizione',
    'Insert desired amount here': 'Inserire l\'importo desiderato',
    'Insert here coupon code': 'Inserisci qui il codice sconto',
    'Insert here the shipping data': 'Inserisci qui i dati di spedizione',
    'Insert here your email to proceed, we will send you just the order updates': 'Inserisci la tua e-mail per procedere, ti invieremo solo le informazioni relative a questo ordine',
    'Insert your billing address': 'Inserisci l\'indirizzo<br>di fatturazione',
    'Insert your Data': 'Inserisci indirizzo di fatturazione',
    'Inviaci il tuo messaggio e noi scriveremo per te una dedica speciale!': 'Inviaci il tuo messaggio e noi scriveremo per te una dedica speciale!',
    'invoice': 'pagamento',
    'Invoice address': 'Fatturazione',
    'It is not possible to use the WE Card points for the entire amount, the minimum payment must be at least 0.05 Euros': 'Non è possibile utilizzare il bonus WE Card points per l\'intera cifra, il pagamento minimo deve essere di almeno 0.05 Euro',
    'Last name': 'Cognome',
    'Lastname': 'Cognome',
    'Leave': 'Esci',
    'Loading': 'Caricamento',
    'Loading payment form, please wait': 'Caricamento del metodo di pagamento in corso, attendere per favore',
    'login': 'Login',
    'Login': 'Accedi',
    'Male': 'Uomo',
    'Message': 'Messaggio',
    'Mobile phone': 'Numero di telefono',
    'Monday': 'Lunedì',
    'Move product': 'Sposta prodotto',
    'Name': 'Nome',
    'New address': 'Nuovo indirizzo',
    'New client': 'Nuovo cliente',
    'No items in cart': 'Il carrello è vuoto',
    'No near stores': 'Nessun negozio trovato',
    'No shipping methods available': 'Nessun metodo di spedizione disponibile',
    'Not registered yet?': 'Non sei ancora registrato?',
    'Ok': 'Ok',
    'Or': 'Oppure',
    'Order detail': 'Dettaglio ordine',
    'Order details': 'Dettaglio Ordine',
    'Order placed': 'Ordine effettuato. Stai per essere redirezionato alla pagina di riepilogo',
    'Order will be shipped to': 'L\'ordine verrà spedito a',
    'Our online shop handles payments in Euros.<br> You will then be charged the amount of:': 'Il nostro store gestisce i pagamenti in Euro.<br> Ti verrà quindi addebitato l\'importo di:',
    'Password': 'Password',
    'Password confirm': 'Conferma password',
    'Pay': 'Paga',
    'payment': 'Pagamento',
    'Payment': 'Pagamento',
    'Payment error.': 'Errore nel pagamento.',
    'Payment method': 'Metodo di pagamento',
    'Personal data': 'Dati personali',
    'Place of birth': 'Luogo di nascita',
    'Place of Birth': 'Luogo di Nascita',
    'Please check zip digits of your address': 'Per favore controlla il CAP del tuo indirizzo',
    'Please verify your gift card code first': 'Verifica il tuo codice gift card prima di procedere',
    'Please wait': 'Attendere prego',
    'Please wait, payment is processing': 'Verifica del pagamento in corso, attendere prego',
    'Postcode': 'CAP',
    'Prefix': 'Prefisso',
    'Proceed': 'Procedi',
    'Proceed delete': 'Procedi',
    'Proceed to payment': 'Procedi al pagamento',
    'Proceed with the purchase': 'Procedi con l\'acquisto',
    'product': 'prodotto',
    'Product': 'Prodotto',
    'products': 'prodotti',
    'Products total': 'Totale prodotti',
    'Quantity': 'Quantità',
    'Register': 'Registrati',
    'Registered User': 'Utente\nregistrato',
    'Registration agreement': 'Regolamento iscrizione',
    'Registration successful': 'Registrazione effettuata con successo',
    'registrationagreement': 'Accetto il <a href="{linkfid}" target="_blank">regolamento fidelity</a> e la <a href="{linkpriv}" target="_blank">privacy policy</a>',
    'Remove': 'Rimuovi',
    'Remove Discount': 'Rimuovi sconto',
    'Remove Gift Card': 'Rimuovi Gift Card',
    'Remove the item': 'Rimuovi articolo',
    'Required fields': 'Campi obbligatori',
    'Retry': 'Riprova',
    'review': 'riepilogo',
    'Safe purchase': 'Acquisto sicuro',
    'Same as billing': 'Uguale all\'indirizzo di fatturazione',
    'Saturday': 'Sabato',
    'Save': 'Salva',
    'Save address': 'Salva indirizzo',
    'Save in address book': 'Salva nella rubrica',
    'Save new address to proceed': 'Registra il nuovo indirizzo prima di procedere',
    'Select': 'Seleziona',
    'Select a city': 'Seleziona la città',
    'Select a payment method': 'Seleziona un metodo di pagamento',
    'Select a region': 'Seleziona la regione',
    'Select here your shipping address': 'Seleziona qui il tuo indirizzo di spedizione',
    'Select payment method': 'Seleziona un metodo di pagamento',
    'Select region': 'Seleziona la provincia',
    'Select shipping method': 'Seleziona un metodo di spedizione',
    'Select store pickup': 'Dove vuoi ritirare?',
    'Select the store': 'Seleziona il negozio',
    'Select this store': 'Seleziona negozio',
    'Select value': 'Seleziona un valore',
    'Selected Store': 'Negozio scelto',
    'Seleziona il metodo di spedizione': 'Seleziona il metodo di spedizione',
    'Send remainder': 'Invia email recupero password',
    'Service unavailable, retry later': 'Errore temporaneo durante la richiesta, riprova tra breve',
    'shipping': 'Spedizione',
    'Shipping': 'Spedizione',
    'Shipping address': 'Indirizzo di spedizione',
    'Shipping and handling': 'Spedizione e gestione',
    'Shipping data': 'Dati di spedizione',
    'Shipping informations': 'Informazioni di spedizione',
    'Shop opening hours': 'Orari di apertura',
    'Shopping Cart': 'Carrello',
    'shopping details': 'dettaglio spesa',
    'Size': 'Taglia',
    'State/Region': 'Provincia',
    'Store selection': 'Scelta del negozio',
    'street': 'via',
    'Street': 'Via',
    'Street number': 'Numero civico',
    'Sunday': 'Domenica',
    'Surname': 'Cognome',
    'Tax included': 'Imposte comprese',
    'Telephone': 'Telefono',
    'Telephone number': 'Numero di telefono',
    'Telephone number for courier / store pickup': 'Numero di telefono per corriere / negozio',
    'Terranova stores near you': 'Negozi terranova vicino a te',
    'The address is the same as another in your address book': 'L\'indirizzo è uguale ad un altro nella tua rubrica',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Il coupon non è valido. Verifica il codice e prova di nuovo.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'La giftcard è esaurita o non valida. Verificare i dati e riprovare.',
    'The maximum value of the usable We+Card bonus is': 'Il valore massimo del bonus WE+Card utilizzabile è',
    'The maximum value of the usable WE+Card points is': 'Il valore massimo dei punti WE Card utilizzabile è',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'La password deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una minuscola, un numero ed un carattere speciale (.;,!$#).',
    'The requested qty is not available': 'La quantità richiesta non è disponibile',
    'There has been an error. Please try again': 'Si è verificato un errore, riprova',
    'This email already esists. Do the login or proceed as guest': 'Questa email esiste già. Effettua il login oppure procedi come ospite',
    'This product is not available, please remove it from cart to proceed': 'Questo prodotto non è disponibile, per favore rimuovilo dal carrello per proseguire',
    'Thursday': 'Giovedì',
    'To': 'A',
    'Total': 'Totale',
    'Tuesday': 'Martedì',
    'Type of card': 'Tipo di carta',
    'Update address': 'Aggiorna indirizzo',
    'use': 'utilizzo',
    'Use bonus': 'Usa bonus',
    'Use Glam Card Bonus': 'Usa Bonus WE+CARD',
    'Use points': 'Usa punti',
    'Use WE+ points': 'Utilizza i Punti WE Card',
    'User': 'Utente',
    'User data': 'Dati cliente',
    'Valid until': 'scade il',
    'VAT number': 'Codice Fiscale',
    'Verify billing address': 'Verifica l\'indirizzo di fatturazione',
    'Verify Gift Card': 'Verifica Gift Card',
    'Verify payment method selection': 'Verifica di aver selezionato un metodo di pagamento',
    'Verify shipping address': 'Verifica l\'indirizzo di spedizione',
    'Verify shipping method selection': 'Verifica di aver selezionato un metodo di spedizione',
    'View your cart': 'Visualizza il tuo carrello',
    'Vuoi impreziosire il tuo regalo con un messaggio personalizzato?': 'Vuoi impreziosire il tuo regalo con un messaggio personalizzato?',
    'Wait for page to reload': 'La pagina sta per essere ricaricata, attendi per favore',
    'We\'re unable to send the password reset email': 'Non è stato possibile inviare la mail di reset password. Controlla l\'email inserita',
    'Wednesday': 'Mercoledì',
    'You are ordering with this email address': 'Stai ordinando con questo indirizzo email',
    'You are shipping in a foreign country': 'Stai spedendo in un paese estero',
    'Your available points': 'Saldo Punti',
    'Your avalaible bonus': 'Saldo Bonus',
    'Zip code': 'CAP',
    'Zip or city': 'Cap o Città',
    'zipdigitwarnings': 'Attenzione il CAP deve essere di {zipdigits} caratteri',
    'Shipping cost excluded': 'Escluse spese di spedizione',
    'Extra address': 'Informazioni aggiuntive  (facoltativo)',
    'Extra address placeholder': 'c/o, interno, frazione, nome sul citofono',
    'Buy now, pay later': 'Compra ora, paga dopo',
    'weplus-pointstonext': 'Ti mancano {expense} di spesa per raggiungere il prossimo livello',
    '8 characters': '8 caratteri',
    '1 lowercase letter': '1 lettera minuscola',
    '1 uppercase letter': '1 lettera maiuscola',
    '1 number':'1 numero',
    '1 special character': '1 carattere speciale',
    'Now you can use your points': 'Ora puoi utilizzare i tuoi punti',
    'Hallo': 'Ciao',
    'Save Credit Card (One Click Payment)': 'Salva carta di credito (pagamento One Click)',
    'Pay with a saved credit card': 'Paga con una carta salvata',
    'Pay with a new credit or debit card': 'Paga con una nuova carta di credito o debito',
    'Expiration': 'Scadenza',
    'Other': 'Altro',
    'Applied discounts': 'Sconti applicati',
    'Complete promo:': 'Completa la promo:',
    'Choose size': 'Seleziona la taglia',
    'Municipality': 'Comune',
    'amount-for-freeshipping': 'Ti mancano {amount} per la spedizione gratuita con corriere',
    'klarna-threshold-warning': 'Il pagamento con Klarna è possibile solo per un importo minimo di {amount} euro',
    'To proceed you must select a payment method': 'Per procedere è necessario selezionare un metodo di pagamento',
    'To proceed you need to save the selected billing address': 'Per procedere è necessario salvare l’indirizzo di fatturazione selezionato',
    'To proceed it is necessary to accept the general conditions of sale': 'Per procedere è necessario accettare le condizioni generali di vendita',
    'To proceed you need to select the store': 'Per procedere è necessario selezionare il negozio',
    'To proceed you need to save your changes': 'Per procedere è necessario salvare le modifiche',
    'Are you sure you want to delete this address?': 'Sei sicuro di voler eliminare questo indirizzo?',
    'To proceed you need to save the selected shipping address': 'Per procedere è necessario salvare l’indirizzo di spedizione selezionato',
    'Select a pickup point': 'Seleziona un punto di ritiro',
    'message-double_optin_using_point_disabled': 'Non puoi utilizzare i punti per questo acquisto in quanto non hai ancora confermato la validità della tua email o del tuo numero di telefono. Per qualsiasi dubbio contatta il nostro customer care.',
};

export default it;
export const itValidation = {
    name: "it",
    messages: {
        _default: function (e: any) {
            return "Il valore del campo " + e + " non è valido."
        },
        after: function (e: any, n: any) {
            return "Il " + e + " deve essere dopo " + n[0] + "."
        },
        alpha: function (e: any) {
            return "Il campo " + e + " può contenere solo caratteri alfabetici."
        },
        alpha_dash: function (e: any) {
            return "Il campo " + e + " può contenere caratteri alfa-numerici così come lineette e trattini di sottolineatura."
        },
        alpha_num: function (e: any) {
            return "Il campo " + e + " può contenere solo caratteri alfanumerici."
        },
        alpha_spaces: function (e: any) {
            return "Il campo " + e + " può contenere solo caratteri alfanumerici così come spazi."
        },
        before: function (e: any, n: any) {
            return "Il campo " + e + " deve essere prima di " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "Il campo " + e + " deve essere compreso tra " + n[0] + " e " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "Il campo " + e + " non corrisponde con " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Il campo " + e + " non è valido."
        },
        date_between: function (e: any, n: any) {
            return "La " + e + " deve essere compresa tra " + n[0] + " e " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "La " + e + " deve essere nel formato " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Il campo " + e + " deve essere numerico e può contenere" + (r && "*" !== r ? " " + r : "") + " punti decimali."
        },
        digits: function (e: any, n: any) {
            return "Il campo " + e + " deve essere numerico e contenere esattamente " + n[0] + " cifre."
        },
        dimensions: function (e: any, n: any) {
            return "Il campo " + e + " deve essere " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "Il campo " + e + " deve essere un indirizzo email valido."
        },
        excluded: function (e: any) {
            return "Il campo " + e + " deve avere un valore valido."
        },
        ext: function (e: any) {
            return "Il campo " + e + " deve essere un file valido."
        },
        image: function (e: any) {
            return "Il campo " + e + " deve essere un'immagine."
        },
        included: function (e: any) {
            return "Il campo " + e + " deve avere un valore valido."
        },
        ip: function (e: any) {
            return "Il campo " + e + " deve essere un indirizzo IP valido."
        },
        length: function (e: any, n: any) {
            return "La lunghezza del campo " + e + " deve essere " + n[0] + " caratteri."
        },
        max: function (e: any, n: any) {
            return "Il campo " + e + " non può essere più lungo di " + n[0] + " caratteri."
        },
        max_value: function (e: any, n: any) {
            return "Il campo " + e + " deve essere minore o uguale a " + n[0]
        },
        mimes: function (e: any) {
            return "Il campo " + e + " deve avere un tipo di file valido."
        },
        min: function (e: any, n: any) {
            return "Il campo " + e + " deve avere almeno " + n[0] + " caratteri."
        },
        min_value: function (e: any, n: any) {
            return "Il campo " + e + " deve essere maggiore o uguale a " + n[0]
        },
        numeric: function (e: any) {
            return "Il campo " + e + " può contenere solo caratteri numerici."
        },
        regex: function (e: any) {
            return "Il campo " + e + " non ha un formato valido."
        },
        required: function (e: any) {
            return "Il campo " + e + " è richiesto."
        },
        size: function (e: any, n: any) {
            return "Il campo " + e + " deve essere inferiore a " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return  v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Il campo " + e + " non è un URL valido."
        },
        'validate-piva-cf': function(e: any) {
            return 'Partita IVA / Codice fiscale non valido.';
        },
        'validate-regionid': function(e: any) {
            return 'Il campo Provincia è richiesto.';
        },
        'validate-ascii': function(e: any) {
            return 'Il campo non deve contenere caratteri speciali';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'I campi via e numero civico non devono superare i {2} caratteri';
        },
        'validate-data-consensus': function(e: any) {
            return "E' richiesto il consenso al uso dei dati personali per procedere.";
        },
        'validate-gender': function(e: any) {
            return 'Il campo Sesso è richiesto.';
        },
        'validate-password': function(e: any) {
            return 'La password deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una minuscola, un numero ed un carattere speciale (.;,!$#).';
        },
    },
    attributes: {}
};
